import { Component, OnInit } from "@angular/core";
import { UserService } from "../../shared/services/user.service";
import { UserDto } from "../../common/dtos/user/user.dto";
import { AuthService } from "../../shared/services/user/auth.service";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "app-backoffice",
  templateUrl: "./backoffice.component.html",
  styleUrls: [
    "./backoffice.component.scss"
  ]
})
export class BackofficeComponent implements OnInit {

  username!: string | undefined;
  user!: UserDto | undefined;

  constructor(
        private userService: UserService,
        private authService: AuthService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.username = this.authService.getUsername()?.replace(/"|\u0027/g, "");
    const result = await lastValueFrom(this.userService.getUsers("username=" + this.username));
    this.user = result.data[0];
    this.userService.setUserDto(this.user);
  }
}
